import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useMemo, useState } from 'react';
export var useCalendar = function useCalendar(params) {
  var valueProp = params.value,
    onChange = params.onChange;
  var _useState = useState(valueProp),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var valueArr = Array.isArray(valueProp) ? valueProp : [valueProp];
  var _useState3 = useState(valueArr[0] || new Date()),
    _useState4 = _slicedToArray(_useState3, 2),
    currentVisibleDate = _useState4[0],
    setCurrentVisibleDate = _useState4[1];
  var _useState5 = useState('date'),
    _useState6 = _slicedToArray(_useState5, 2),
    mode = _useState6[0],
    setMode = _useState6[1];
  var onComplete = function onComplete(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value, e);
  };
  useEffect(function () {
    setValue(valueProp);
    var firstDate = Array.isArray(valueProp) ? valueProp[0] : valueProp;
    if (firstDate) {
      setCurrentVisibleDate(firstDate);
    }
  }, [valueProp]);
  return useMemo(function () {
    return {
      currentVisibleDate: currentVisibleDate,
      setCurrentVisibleDate: setCurrentVisibleDate,
      mode: mode,
      value: value,
      onComplete: onComplete,
      setValue: setValue,
      setMode: setMode
    };
  }, [mode, value, currentVisibleDate]);
};